<template>
    <label class="checkbox" :class="customClass">
        <input
            :id="context.name || $attrs.name"
            class="checkbox__input"
            :checked="shouldBeChecked"
            :value="value"
            type="checkbox"
            :disabled="disabled"
            :required="required"
            :name="context.name || $attrs.name"
            @change="onChange"
        />
        <span class="checkbox__checkmark" />
        <div>
            <slot>{{ label }}</slot>
        </div>
        <slot name="append" />
    </label>
</template>

<script>
const noop = () => {};
const empty = () => ({});

export default {
    name: 'Checkbox',
    emits: ['update:modelValue'],
    props: {
        value: {},
        modelValue: {
            default: false
        },
        trueValue: {
            default: true
        },
        falseValue: {
            default: false
        },
        label: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: ''
        },
        theme: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        }
    },

    inject: {
        context: {
            default: empty
        },
        registerControl: {
            default: () => noop
        }
    },

    computed: {
        shouldBeChecked() {
            if (Array.isArray(this.modelValue)) {
                return this.modelValue.includes(this.value);
            }

            return this.modelValue === this.value || this.modelValue === this.trueValue;
        },
        customClass() {
            let classNames = [];

            if (this.size.length) {
                classNames.push(`checkbox--${this.size}`);
            }

            if (this.theme) {
                classNames.push(`checkbox--${this.theme}`);
            }

            if (this.disabled) {
                classNames.push('is-disabled');
            }

            return classNames.join(' ');
        }
    },

    mounted() {
        this.registerControl(this);
    },

    methods: {
        onChange(event) {
            let isChecked = event.target.checked;

            if (Array.isArray(this.modelValue)) {
                let newValue = [...this.modelValue];

                if (isChecked) {
                    newValue.push(this.value);
                } else {
                    newValue.splice(newValue.indexOf(this.value), 1);
                }

                this.$emit('update:modelValue', newValue);
            } else {
                this.$emit('update:modelValue', isChecked ? this.trueValue : this.falseValue);
            }
        }
    }
};
</script>

<style lang="scss" src="./Checkbox.scss"></style>
